import {Injectable, inject} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {AuthenticationService} from '../_services/authentication.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {stringify} from 'flatted';
import {I18nService} from '../_services/gui/i18n.service';
import {AppConfig} from '../_data/config/app-config';
import {BYPASS_ERROR_INTERCEPTOR} from '../_constants/constants';

/**
 * Automatically logs out a user if the backend service returns that a user is not authenticated.
 */
@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  private authenticationService = inject(AuthenticationService);
  private i18nService = inject(I18nService);
  private _snackBar = inject(MatSnackBar);
  private appConfig = inject(AppConfig);


  private generalErrorMessage: string;

  constructor() {
    const i18nService = this.i18nService;

    i18nService.getTranslation('content.error-occurred').subscribe(value => this.generalErrorMessage = value);
  }

  private snackBarError(err) {
    if(this.appConfig.production) {
      console.error('Unexpected Error!');
    } else {
      console.error(`${stringify(err)}`);
    }
    this._snackBar.open(this.generalErrorMessage, null, {duration: 3000, panelClass: ['tu-snackbar']});
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if(request.context.get(BYPASS_ERROR_INTERCEPTOR)) {
      console.debug('Request bypassing error interceptor');
      return next.handle(request);
    }

    return next.handle(request).pipe(catchError(err => {

      if(err.error instanceof ErrorEvent) {
        console.error('A client-side or network error occurred:', err.error.message);
        this.snackBarError(err);
      } else if(err.error && err.error.error instanceof SyntaxError) {
        console.error('A syntax error has occurred:', err.error.error.message);
        this.snackBarError(err);
      } else {
        if(err.status === 0 || err.status >= 400) {
          this.snackBarError(err);
        } else {
          console.warn(`Response http status: ${err.status} - ${typeof err}`);
        }
      }

      return throwError(err);

    }));
  }
}
